(function () {
    'use strict';

    angular
        .module('harriApp')
        .service('announcementsService', AnnouncementsService);

    function AnnouncementsService() {
        var self = this;

        self.TALENT_POOL_DEMO = 'TALENT_POOL_DEMO';
        self.INTERVIEW_SCHEDULING_DEMO = 'INTERVIEW_SCHEDULING_DEMO';
        self.CARRI_WALKME = 'CARRI_WALKME';
        self.PERMISSIONS = 'PERMISSIONS';
        self.LMS_HARASSMENT = 'LMS_HARASSMENT';
        self.LMS_VIDEO_DEMO = 'LMS_VIDEO_DEMO';
        self.HEALTH_CHECK_DEMO = 'HEALTH_CHECK_DEMO';

        var announcements;

        var getAnnouncements = function () {
            var defer = $q.defer();
            if (announcements) {
                defer.resolve(announcements);
            } else {
                WelcomeStatusAPI.getStatus().then(function (res) {
                    announcements = res;
                    defer.resolve(announcements);
                }, function () {
                    defer.reject();
                });
            }
            return defer.promise;
        };

        var getAnnouncementByType = function (announcementType) {
            return _.find(announcements, function (record) {
                return record.code === announcementType;
            });
        };

        self.resetAnnouncements = function(){
            WelcomeStatusAPI.resetResults();
            announcements = undefined;
        };

        self.hasAnnouncement = function (announcementType) {
            var defer = $q.defer();

            getAnnouncements().then(function () {
                var record = getAnnouncementByType(announcementType);
                if (!record) {
                    defer.resolve(false);
                } else {
                    defer.resolve(record.status === 'NEW');
                }
            }, function () {
                defer.reject();
            });

            return defer.promise;
        };

        self.dismiss = function (announcementType) {
            var defer = $q.defer();

            var record = getAnnouncementByType(announcementType);

            if (record && record.status === 'NEW') {
                WelcomeStatusAPI.dismiss(record.id).then(function (res) {
                    defer.resolve(res);
                }, function () {
                    defer.reject();
                });
            }

            return defer.promise;
        };

        self.requestDemo = function (brandId, announcementType) {
            var defer = $q.defer();

            var record = getAnnouncementByType(announcementType);

            var params = {
                brand_id: brandId
            };

            WelcomeStatusAPI.requestDemo(record.id, params).then(function (res) {
                defer.resolve(res);
            }, function () {
                defer.reject();
            });

            return defer.promise;
        };
    }

    AnnouncementsService.$inject = [];

})();
